'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    -webkit-transform:rotate(', 'deg);\n    transform: rotate(', 'deg);\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 300px;\n    width: 300px;\n    border-radius: 50%;\n    transition : all 1s;\n    clip : ', ';\n    z-index : ', '\n'], ['\n    -webkit-transform:rotate(', 'deg);\n    transform: rotate(', 'deg);\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 300px;\n    width: 300px;\n    border-radius: 50%;\n    transition : all 1s;\n    clip : ', ';\n    z-index : ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Slice = _styledComponents2.default.div(_templateObject, function (props) {
    return props.slicedegree;
}, function (props) {
    return props.slicedegree;
}, function (props) {
    return props.clipnative ? 'rect(0px, 300px, 300px, 150px)' : 'auto';
}, function (props) {
    return props.z_axis;
});
exports.default = Slice;